import { CdkDrag, CdkDragDrop, CdkDropList, moveItemInArray, transferArrayItem } from "@angular/cdk/drag-drop";
import { F } from "@angular/cdk/keycodes";
import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { columnDef, columnOption } from "../aegis-grid/aegis-grid.component";

export class options {
  Columns: Record<string, columnOption>
  DisplayColumns: columnDef[];
}

@Component({
  selector: 'app-aegis-grid-options-dialog',
  templateUrl: './aegis-grid-options-dialog.component.html',
  styleUrls: ['./aegis-grid-options-dialog.component.scss'],
  imports: [CdkDropList, CdkDrag]
})
export class AegisGridOptionsDialogComponent  {
  private visibleList: string[] = [];
  private hiddenList: string[] = [];
  private displayColumns: columnDef[];

  private search: string;
  private dragging: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<AegisGridOptionsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: options) {
    this.visibleList = Object.entries(data?.Columns).filter(([prop, data]) => !data.hidden && !data.removed).map(([prop, data]) => ({ prop, order: data.order })).sort((a, b) => a.order - b.order).map((item) => item.prop);
    this.hiddenList = Object.entries(data?.Columns).filter(([prop, data]) => !!data.hidden && !data.removed).map(([prop, data]) => ({ prop, order: data.order })).sort((a, b) => a.order - b.order).map((item) => item.prop);
    this.displayColumns = data.DisplayColumns;
  }

  getColumnName(key: string) {
    var foundItem = this.displayColumns.filter((val) => val.Name == key);

    if (foundItem.length > 0) {
      if (foundItem[0].Display)
        return foundItem[0].Display;
      else if (foundItem[0].DisplayName)
        return foundItem[0].DisplayName;
      else
        return foundItem[0].Name;
    }

    return key;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onOkClick(): void {
    for (var i = 0; i < this.visibleList.length; i++) {
      var colName = this.visibleList[i];

      this.data.Columns[colName].hidden = false;
      this.data.Columns[colName].order = i;
    }

    for (var i = 0; i < this.hiddenList.length; i++) {
      var colName = this.hiddenList[i];

      this.data.Columns[colName].hidden = true;
      this.data.Columns[colName].order = i;
    }

    this.dialogRef.close(this.data);
  }

  onResetClick(): void {
    this.dialogRef.close(<options>{
      Columns: {}
    });
  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
  }

  itemVisible(item: string): boolean {
    if (!this.dragging && this.search && item.toLowerCase().indexOf(this.search.toLowerCase()) <= -1) {
      return false;
    }

    return true;
  }

  isFixed(key: string): boolean {
    var foundItem = this.displayColumns.filter((val) => val.Name == key);

    if (foundItem.length > 0)
      return (foundItem[0].ColumnSettings?.Fixed ?? false);

    return false;
  }

  isFrontFixed(key: string): boolean {
    var foundItem = this.displayColumns.filter((val) => val.Name == key);

    if (foundItem.length > 0)
      return (foundItem[0].ColumnSettings?.FrontFixed ?? false);

    return false;
  }

  hide(item: string) {
    var idx = this.visibleList.indexOf(item);

    if (idx > -1) {
      this.visibleList.splice(idx, 1);
      this.hiddenList.push(item);
    }
  }

  show(item: string) {
    var idx = this.hiddenList.indexOf(item);

    if (idx > -1) {
      this.hiddenList.splice(idx, 1);
      this.visibleList.push(item);

      var frontFixed = this.visibleList.filter(item => {
        var column = this.displayColumns.find(item2 => item2.Name == item);

        if (column?.ColumnSettings?.FrontFixed)
          return true;

        return false;
      });

      var nonFixed = this.visibleList.filter(item => {
        var column = this.displayColumns.find(item2 => item2.Name == item);

        if (!column || (!column.ColumnSettings?.Fixed && !column.ColumnSettings?.FrontFixed))
          return true;

        return false;
      });

      var fixed = this.visibleList.filter(item => {
        var column = this.displayColumns.find(item2 => item2.Name == item);

        if (column?.ColumnSettings?.Fixed)
          return true;

        return false;
      });

      this.visibleList = [];

      this.visibleList = this.visibleList.concat(frontFixed);
      this.visibleList = this.visibleList.concat(nonFixed);
      this.visibleList = this.visibleList.concat(fixed);
    }
  }
}
